import { LabelTheme } from '@zopauk/react-components/types/components/styles/Theme';

export const label: LabelTheme = {
  margin: `0 0 8px`,
};
